import { Modal, Radio } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import { CloseActionBtn } from '../../lib/Resources';

export const AdminFilterModal = ({
  visible,
  onCancel,
}: {
  visible: boolean;
  onCancel: () => void;
}) => {
  const { pathname, push, query } = useRouter();
  const { t } = useTranslation();
  const [valueSelected, setValueSelected] = useState(query?.filterBy || '');

  async function onFilterChange({ target }) {
    setValueSelected(target.value);
    push({
      pathname,
      query: {
        ...query,
        filterBy: target.value,
      },
    });
  }

  const radioStyle = {
    display: 'block',
    height: '30px',
    lineHeight: '30px',
  };

  return (
    <Modal
      title=""
      visible={visible}
      centered
      onCancel={onCancel}
      footer={null}
      className="popup-filter-modal"
      closeIcon={
        <div>
          <img src={CloseActionBtn} alt="Close action" height={20} width={20} />
        </div>
      }
    >
      <div className="account-modal-div">
        <div>
          <div className="filter-by-title">{t('Order By')}</div>

          <Radio.Group onChange={onFilterChange} value={valueSelected}>
            <div className="account-lower-part-text" role="button" tabIndex={0}>
              <Radio style={radioStyle} value="">
                {t('All')}
              </Radio>
            </div>

            <div
              className="account-lower-part-text"
              role="button"
              tabIndex={-8}
            >
              <Radio style={radioStyle} value="banned">
                {t('Banned')}
              </Radio>
            </div>

            <div
              className="account-lower-part-text"
              role="button"
              tabIndex={-12}
            >
              <Radio style={radioStyle} value="notAllowedToMint">
                {t('Minting Disabled')}
              </Radio>
            </div>

            <div
              className="account-lower-part-text"
              role="button"
              tabIndex={-14}
            >
              <Radio style={radioStyle} value="verified">
                {t('Verified')}
              </Radio>
            </div>

            <div
              className="account-lower-part-text"
              role="button"
              tabIndex={-16}
            >
              <Radio style={radioStyle} value="leaderboard">
                {t('Leaderboard')}
              </Radio>
            </div>
          </Radio.Group>
        </div>
      </div>
    </Modal>
  );
};
